/* 09/01/2025 - CSS for Add to car disable throughout the site*/
$(document).ready(function(){
  
  // $('.product .product__info-wrapper .product-form .product-form__submit').click(function(event) {
  //   event.preventDefault(); // Prevent the default action
  //   event.stopImmediatePropagation(); // Stop other click handlers from executing
  //   console.log('mainATC button is disabled.');
  // });
  
  // $('.cust_stickyCart_inner .stickySubmitWrap .addToCart').click(function(event) {
  //   event.preventDefault(); // Prevent the default action
  //   event.stopImmediatePropagation(); // Stop other click handlers from executing
  //   console.log('stickyATC button is disabled.');
  // });


  $(".openSizePop").click(function(){
    $(".sizePopOverlay").show();
    $(".sizePopMain").show();
  });
  $(".closeIt").click(function(){
    $(".sizePopOverlay").hide();
    $(".sizePopMain").hide();
  });  
  
})
/* 09/01/2025 - CSS for Add to car disable throughout the site*/